





















































import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FinalizarImportacaoDeNotaDoFornecedorUseCase } from '@/usecases'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
	components: {

	},
})
export default class DialogoDeImportarNotaEmPedidos extends Vue {
	@Prop({ default: '500' }) width!: string

	mostra: boolean | null = null
	errors: string[] = []
	file: File | null = null
	carregando = false
	pedidoId = ''

	finalizarImportacaoDeNotaDoFornecedorUseCase = new FinalizarImportacaoDeNotaDoFornecedorUseCase()


	async mostrar(pedidoId: string) {
		this.mostra = true
		this.pedidoId = pedidoId
	}

	cancelar() {
		this.file = null
		this.mostra = false
	}

	async confirma() {
		if (!this.file) {
			AlertModule.setError('Necessário selecionar um xml para importação.')
			return
		}
		this.carregando = true
		try {
			const pedido = await this.finalizarImportacaoDeNotaDoFornecedorUseCase.importarNotaFiscalParaPedido(this.file, this.pedidoId)
			this.mostra = false
			this.file = null
			this.$emit('nota-importada', pedido)
			AlertModule.setSuccess("Nota importada com sucesso!")
		}
		catch(error: any){
			AlertModule.setError(error)
		} finally{
			this.carregando = false
		}
	}

}
